import {
    WHITEBOARD_HISTORY_CLEAR,
    WHITEBOARD_HISTORY_PUSH,
    WHITEBOARD_HISTORY_REDO,
    WHITEBOARD_HISTORY_UNDO,
    WHITEBOARD_HISTORY_UPDATE,
} from "constants/action-types";
import { EventTypes } from "redux-segment";

export const push = (payload) => ({
    payload,
    type: WHITEBOARD_HISTORY_PUSH,
});

export const update = (undo, redo) => ({
    payload: {
        redo,
        undo,
    },
    type: WHITEBOARD_HISTORY_UPDATE,
});

export const undo = () => ({
    meta: {
        analytics: EventTypes.track,
    },
    type: WHITEBOARD_HISTORY_UNDO,
});

export const redo = () => ({
    meta: {
        analytics: EventTypes.track,
    },
    type: WHITEBOARD_HISTORY_REDO,
});

export const clear = () => ({
    type: WHITEBOARD_HISTORY_CLEAR,
});
